export default __webpack_public_path__ + "static/media/digital-label-icon-first.764ab616.svg";